<template>
  <div>
    <h1>添加品牌</h1>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="品牌名称"
      >
        <a-input
          v-decorator="[
          'name',
          {rules: [{ required: true, message: '必填项' }]}
        ]"
          placeholder="品牌名称"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="排序"
      >
        <a-input v-decorator="[
          'sortNo',
        ]" placeholder="排序"/>
      </a-form-item>
      <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
        <div>
          <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
          <a-button @click="goBack">取消</a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
export default {
  name: "brandAdd",
  data() {
    return {
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post("/api/1.0/brand/save", values).then(res => {
            this.$http.ajaxResultDue(res, "/brand", null);
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
